import { action, get } from "@ember/object"
import { inject as service } from "@ember/service"
import Component from "@glimmer/component"
import type { Group, IndividualMembership } from "@shared/models/group"
import type SchoolYear from "@shared/models/school-year"
import FindDoc from "cc-frontend/helpers/find-doc"
import type { LiveQueryResult } from "cc-frontend/helpers/live-query"
import type ModalManager from "cc-frontend/services/modal-manager"
import { isGroupMembershipAccepted } from "cc-frontend/utils/group"
import { use } from "ember-could-get-used-to-this"
import { filter, includes, isNil } from "lodash-es"
import * as R from "remeda" // tree-shaking supported!

interface Signature {
  Args: {
    row: IndividualMembership
    planbooksSharedWithGroup: Array<LiveQueryResult>
    group: Group
    parentGroup: Group | null
    teamIds: Array<string>
    isFetchingPlanbooksQuery: boolean
    selectedSchoolYear: SchoolYear | null
  }
}

export default class GroupMembersTablePlanbooksCell extends Component<Signature> {
  @service declare modalManager: ModalManager

  @use userSummary = new FindDoc(() => {
    let userId
    if (isGroupMembershipAccepted(this.args.row)) {
      userId = get(get(this.args.row, "attributes"), "userId")
    } else {
      userId = null
    }
    return ["user-summary", userId]
  })

  get planbooks() {
    if (this.userSummary.content === null) return []
    let planbooks = get(get(this.userSummary.content, "relationships"), "planbooks")
    if (isNil(planbooks)) return []
    let userPlanbookIds = R.map(get(planbooks, "data"), (el) => get(el, "id"))
    return filter(this.args.planbooksSharedWithGroup, (result) =>
      includes(userPlanbookIds, get(result, "id"))
    )
  }

  @action
  openSelectPlanbooks() {
    if (this.userSummary.content) {
      this.modalManager.openModal("group/share-unshare-planbooks", {
        userSummary: this.userSummary.content,
        group: this.args.group,
        parentGroup: this.args.parentGroup,
        teamIds: this.args.teamIds,
      })
    }
  }
}

declare module "@glint/environment-ember-loose/registry" {
  export default interface Registry {
    "Group::MembersTable::Cells::Planbooks": typeof GroupMembersTablePlanbooksCell
  }
}
